'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.TagListWrapper = exports.DetailListWrapper = exports.FormTextField = exports.StandardFormField = exports.BasicDetailList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BasicDetailList = function BasicDetailList(_ref) {
	var labelText = _ref.labelText,
	    value = _ref.value,
	    className = _ref.className,
	    ExtraHintComponent = _ref.ExtraHintComponent,
	    otherProps = _objectWithoutProperties(_ref, ['labelText', 'value', 'className', 'ExtraHintComponent']);

	return _react2.default.createElement(
		_reactBootstrap.Row,
		_extends({ className: (0, _classnames2.default)(className, 'detail-list-item') }, otherProps),
		_react2.default.createElement(
			'dt',
			{ className: 'col-xs-2' },
			labelText
		),
		_react2.default.createElement(
			'dd',
			{ className: 'col-xs-10' },
			_react2.default.createElement(
				'div',
				{ className: 'pull-left col-xs-6 form-group' },
				value,
				ExtraHintComponent || null
			)
		)
	);
};

exports.BasicDetailList = BasicDetailList;
BasicDetailList.propTypes = {
	labelText: _propTypes2.default.string.isRequired,
	value: _propTypes2.default.string.isRequired,
	ExtraHintComponent: _propTypes2.default.node
};

var StandardFormField = exports.StandardFormField = function StandardFormField(_ref2) {
	var inputType = _ref2.inputType,
	    value = _ref2.value,
	    onChange = _ref2.onChange,
	    onKeyDown = _ref2.onKeyDown,
	    placeholder = _ref2.placeholder,
	    type = _ref2.type;
	return _react2.default.createElement(_reactBootstrap.FormControl, {
		componentClass: inputType,
		value: value,
		onChange: onChange,
		onKeyDown: onKeyDown,
		placeholder: placeholder,
		type: type
	});
};

StandardFormField.propTypes = {
	inputType: _propTypes2.default.string,
	value: _propTypes2.default.string.isRequired,
	onChange: _propTypes2.default.func.isRequired,
	onKeyDown: _propTypes2.default.func,
	placeholder: _propTypes2.default.string,
	type: _propTypes2.default.string
};

var FormTextField = function FormTextField(_ref3) {
	var labelText = _ref3.labelText,
	    className = _ref3.className,
	    ExtraHintComponent = _ref3.ExtraHintComponent,
	    isValid = _ref3.isValid,
	    validation = _ref3.validation,
	    children = _ref3.children,
	    isRequired = _ref3.isRequired,
	    otherProps = _objectWithoutProperties(_ref3, ['labelText', 'className', 'ExtraHintComponent', 'isValid', 'validation', 'children', 'isRequired']);

	var _validation$helpMsg = validation.helpMsg,
	    helpMsg = _validation$helpMsg === undefined ? function () {
		return null;
	} : _validation$helpMsg;

	return _react2.default.createElement(
		_reactBootstrap.Row,
		_extends({ className: (0, _classnames2.default)(className, 'detail-list-item') }, otherProps),
		_react2.default.createElement(
			'dt',
			{ className: 'col-xs-2' },
			isRequired ? _react2.default.createElement(
				'span',
				{ className: 'blue-steel' },
				'*'
			) : null,
			' ',
			labelText
		),
		_react2.default.createElement(
			'dd',
			{ className: 'col-xs-10' },
			_react2.default.createElement(
				_reactBootstrap.FormGroup,
				{ className: 'pull-left col-xs-6', validationState: !isValid ? 'error' : null },
				children
			),
			_react2.default.createElement(
				'div',
				{ className: 'pull-left col-xs-6 hint' },
				ExtraHintComponent || null,
				!isValid && _react2.default.createElement(
					_reactBootstrap.HelpBlock,
					{ className: 'help-text' },
					helpMsg()
				)
			)
		)
	);
};

exports.FormTextField = FormTextField;
FormTextField.propTypes = {
	labelText: _propTypes2.default.string.isRequired,
	isRequired: _propTypes2.default.bool,
	ExtraHintComponent: _propTypes2.default.node,
	isValid: _propTypes2.default.bool,
	children: _propTypes2.default.node,
	placeholder: _propTypes2.default.string
};

var DetailListWrapper = exports.DetailListWrapper = function (_React$Component) {
	_inherits(DetailListWrapper, _React$Component);

	function DetailListWrapper(props) {
		_classCallCheck(this, DetailListWrapper);

		var _this = _possibleConstructorReturn(this, (DetailListWrapper.__proto__ || Object.getPrototypeOf(DetailListWrapper)).call(this, props));

		_this.onChange = _this.onChange.bind(_this);
		return _this;
	}

	_createClass(DetailListWrapper, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _props = this.props,
			    validation = _props.validation,
			    name = _props.name,
			    initValue = _props.initValue,
			    addInvalidAttr = _props.addInvalidAttr;

			if (validation && validation.requireValidation && typeof validation.validate === 'function') {
				addInvalidAttr(name, !validation.validate(initValue));
			}
		}
	}, {
		key: 'onChange',
		value: function onChange(event) {
			var value = event.target && event.target.value;
			var _props2 = this.props,
			    validation = _props2.validation,
			    name = _props2.name,
			    stateChangeCallback = _props2.stateChangeCallback,
			    addInvalidAttr = _props2.addInvalidAttr;

			stateChangeCallback(name, value);
			if (validation && validation.requireValidation && typeof validation.validate === 'function') {
				addInvalidAttr(name, !validation.validate(value));
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props3 = this.props,
			    inputType = _props3.inputType,
			    value = _props3.value,
			    editDisabled = _props3.editDisabled,
			    placeholder = _props3.placeholder,
			    type = _props3.type,
			    isRequired = _props3.isRequired,
			    otherProps = _objectWithoutProperties(_props3, ['inputType', 'value', 'editDisabled', 'placeholder', 'type', 'isRequired']);

			if (editDisabled) {
				var className = otherProps.className,
				    ExtraHintComponent = otherProps.ExtraHintComponent,
				    extraProps = _objectWithoutProperties(otherProps, ['className', 'ExtraHintComponent']);

				var props = _extends({}, extraProps, { value: value, className: className, ExtraHintComponent: ExtraHintComponent });
				return _react2.default.createElement(BasicDetailList, props);
			}
			var field = _react2.default.createElement(StandardFormField, { inputType: inputType, value: value, onChange: this.onChange, placeholder: placeholder, type: type });

			return _react2.default.createElement(
				FormTextField,
				_extends({}, otherProps, { value: value, isRequired: isRequired }),
				field
			);
		}
	}]);

	return DetailListWrapper;
}(_react2.default.Component);

DetailListWrapper.propTypes = {
	labelText: _propTypes2.default.string.isRequired,
	value: _propTypes2.default.string.isRequired,
	editDisabled: _propTypes2.default.bool,
	inputType: _propTypes2.default.string,
	ExtraHintComponent: _propTypes2.default.node,
	validation: _propTypes2.default.object,
	placeholder: _propTypes2.default.string,
	type: _propTypes2.default.oneOf(['text', 'password']),
	isRequired: _propTypes2.default.bool
};
DetailListWrapper.defaultProps = {
	placeholder: '',
	isRequired: false
};

var TagListWrapper = exports.TagListWrapper = function (_React$Component2) {
	_inherits(TagListWrapper, _React$Component2);

	function TagListWrapper() {
		_classCallCheck(this, TagListWrapper);

		return _possibleConstructorReturn(this, (TagListWrapper.__proto__ || Object.getPrototypeOf(TagListWrapper)).apply(this, arguments));
	}

	_createClass(TagListWrapper, [{
		key: 'render',
		value: function render() {
			var _props4 = this.props,
			    inputType = _props4.inputType,
			    value = _props4.value,
			    tagOnChange = _props4.tagOnChange,
			    tagFieldOnKeyDown = _props4.tagFieldOnKeyDown,
			    _props4$SpecialRender = _props4.SpecialRenderer,
			    SpecialRenderer = _props4$SpecialRender === undefined ? null : _props4$SpecialRender,
			    tagOnDelete = _props4.tagOnDelete,
			    placeholder = _props4.placeholder,
			    isRequired = _props4.isRequired,
			    isValid = _props4.isValid,
			    TagValidationHelp = _props4.TagValidationHelp,
			    otherProps = _objectWithoutProperties(_props4, ['inputType', 'value', 'tagOnChange', 'tagFieldOnKeyDown', 'SpecialRenderer', 'tagOnDelete', 'placeholder', 'isRequired', 'isValid', 'TagValidationHelp']);

			var tags = Array.isArray(otherProps.tags) ? otherProps.tags : [otherProps.tags];
			var inputField = _react2.default.createElement(StandardFormField, { inputType: inputType, value: value, onChange: tagOnChange, onKeyDown: tagFieldOnKeyDown, placeholder: placeholder });
			if (SpecialRenderer && typeof SpecialRenderer === 'function') {
				SpecialRenderer.displayName = 'ListOfTags';
			}
			return _react2.default.createElement(
				FormTextField,
				_extends({}, otherProps, { value: value, isRequired: isRequired, isValid: isValid }),
				inputField,
				_react2.default.createElement(
					'div',
					null,
					!isValid && TagValidationHelp && _react2.default.createElement(
						'div',
						{ className: 'hint' },
						_react2.default.createElement(TagValidationHelp, { className: 'help-text help-block' }),
						_react2.default.createElement('br', null)
					),
					SpecialRenderer !== null && _react2.default.createElement(SpecialRenderer, { tags: Array.isArray(tags) ? tags : [tags], onDelete: tagOnDelete })
				)
			);
		}
	}]);

	return TagListWrapper;
}(_react2.default.Component);

TagListWrapper.propTypes = {
	inputType: _propTypes2.default.string,
	value: _propTypes2.default.string.isRequired,
	ExtraHintComponent: _propTypes2.default.node,
	tagOnChange: _propTypes2.default.func,
	tagFieldOnKeyDown: _propTypes2.default.func,
	tagOnDelete: _propTypes2.default.func,
	placeholder: _propTypes2.default.string,
	isRequired: _propTypes2.default.bool

};

TagListWrapper.defaultProps = {
	placeholder: '',
	isRequired: false
};

var _default = {
	DetailListWrapper: DetailListWrapper,
	TagListWrapper: TagListWrapper
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(BasicDetailList, 'BasicDetailList', 'src/components/DetailList.jsx');

	__REACT_HOT_LOADER__.register(StandardFormField, 'StandardFormField', 'src/components/DetailList.jsx');

	__REACT_HOT_LOADER__.register(FormTextField, 'FormTextField', 'src/components/DetailList.jsx');

	__REACT_HOT_LOADER__.register(DetailListWrapper, 'DetailListWrapper', 'src/components/DetailList.jsx');

	__REACT_HOT_LOADER__.register(TagListWrapper, 'TagListWrapper', 'src/components/DetailList.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/DetailList.jsx');
}();

;